import { useQuery } from "@tanstack/react-query";
import { Charge } from "../../models/Charge";
import { getCharges } from "../../repositories/ChargeRepository";

export const useFilteredChargesQuery = (
  startDate: Date | null,
  endDate: Date | null,
  refetchInterval: number,
) => {
  const startKey = startDate?.toISOString() ?? "";
  const endKey = endDate?.toISOString() ?? "";

  return useQuery({
    queryKey: ["charges", startKey, endKey],
    queryFn: async ({ signal }) => {
      const resp = await getCharges(
        {
          startDate,
          endDate,
        },
        signal,
      );
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as Charge[];
      }
      throw new Error(resp.message);
    },
    enabled: !!startDate && !!endDate,
    refetchInterval: refetchInterval > 0 ? refetchInterval * 1000 : false,
  });
};
